export default "__VITE_ASSET__DzfzMjYy__"